import { render, staticRenderFns } from "./NavigationButton.vue?vue&type=template&id=403bef4f&scoped=true&"
import script from "./NavigationButton.vue?vue&type=script&lang=js&"
export * from "./NavigationButton.vue?vue&type=script&lang=js&"
import style0 from "./NavigationButton.vue?vue&type=style&index=0&id=403bef4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403bef4f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
